import AccountsService from "./accounts/accounts";
import ApiKeysService from "./apiKeys/apiKeys";
import CommunitySearchService from "./files/community-search";
import ConvertImageService from "./files/convert-image";
import DomainFederationsService from "./domain-federations/domainFederations";
import DomainsService from "./domains/domains";
import FilesService from "./files/files";
import HttpClient from "./HttpClient";
import LogEventsBeaconService from "./log-events/logEvents";
import NotificationsService from "./notifications/notifications";
import OrganizationsService from "./admin/organizations";
import OvdNsdConverterService from "./ovd-nsd-converter/ovdNsdConverter";
import ParentOrganizationsService from "./admin/parentOrganizations";
import SavedFiltersService from "./saved-filters/savedFilters";
import TexturesServices from "./textures/texturesService";
import VesselsMasterDataService from "./vessels-master-data/vesselsMasterData";
import readOVDJsonFile from "./ovd-json/file/readOVDJson";
import stafFileConvertToOVD from "./import-staf/stafFileConvertToOVD";
import stafFileReadShipData from "./import-staf/stafFileReadShipData";

const Services = {
  resetInternalData: async () => {
    const client = new HttpClient();
    return await client.request<void>({
      method: "GET",
      url: "/",
    });
  },

  ovdJson: {
    readFile: {
      readOVDJsonFile,
    },
  },
  importStaf: {
    stafFileConvertToOVD,
    stafFileReadShipData,
  },
  ovdNsdConverter: {
    ...OvdNsdConverterService,
  },
  organizations: {
    ...OrganizationsService,
  },
  files: {
    ...FilesService,
    ...ConvertImageService,
  },
  vesselsMasterData: {
    ...VesselsMasterDataService,
  },
  accounts: {
    ...AccountsService,
  },

  domainFederations: {
    ...DomainFederationsService,
  },
  apiKeys: {
    ...ApiKeysService,
  },
  vesselSearch: {
    ...CommunitySearchService,
  },
  logEvents: {
    ...LogEventsBeaconService,
  },
  notifications: {
    ...NotificationsService,
  },
  savedFilters: {
    ...SavedFiltersService,
  },
};

export const AdminServices = {
  domains: {
    ...DomainsService,
  },
  parentOrganizations: {
    ...ParentOrganizationsService,
  },
  textures: { ...TexturesServices },
};

if (
  process.env.NX_PUBLIC_STAGE === "dev" ||
  process.env.NX_PUBLIC_STAGE === "alpha"
)
  window.tvdServices = Services;

export default Services;
